import { useEffect } from 'react';

const CSMChatWidget = ({ isConfigAgentEnabled }) => {
    useEffect(() => {
        const loadScript = (url) => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true; // or script.defer = true;
            script.dataset.testid = 'csm-chat-widget-script';
            document.body.append(script);
        };

        const checkAndLoadWidget = () => {
            const widget = document.querySelector(
                '#atlassian-conversation-assistant-widget'
            );
            if (!widget) {
                window.ENABLE_SAC_CONFIG_CSM_AGENT_EXP =
                    isConfigAgentEnabled ?? false;
                loadScript(`${window.CSM_CHAT_WIDGET_BASE_URL}/installer.js`);
            }
        };

        checkAndLoadWidget();
    }, [isConfigAgentEnabled]);
    return null;
};

export default CSMChatWidget;
